<template>
    <div>

        <el-form :model="setForm"  :rules="rules" ref="setFormRef">
            <el-card>
                <el-row :gutter="20">

                    <el-col :span="6" v-for="(ii,kk,index) in setForm" v-if="index<3" >

                        <el-form-item :prop=kk :label=lable[kk]>
                            <div v-for="(item,index) in setForm[kk]">
                                <el-row :gutter="20">
                                    <el-col :span="21">
                                        <el-input  v-model="setForm[kk][index]"  ></el-input>
                                    </el-col>
                                    <el-col :span="3">
                                        <i class="el-icon-delete"  title="Delete" @click="deleteItem(kk, index)"></i>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-button class="button-new-tag" size="small" @click="addinput(kk)">+ New </el-button>
                        </el-form-item>

                    </el-col>

                </el-row>

                <el-row :gutter="20">

                    <el-col :span="6" v-for="(ii,kk,index) in setForm" v-if="index>=3" >

                        <el-form-item :prop=kk :label=lable[kk]>
                            <div v-for="(item,index) in setForm[kk]">
                                <el-row :gutter="20">
                                    <el-col :span="21">
                                        <el-input  v-model="setForm[kk][index]"  ></el-input>
                                    </el-col>
                                    <el-col :span="3">
                                        <i class="el-icon-delete" title="Delete" @click="deleteItem(kk, index)"></i>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-button class="button-new-tag" size="small" @click="addinput(kk)">+ New </el-button>
                        </el-form-item>

                    </el-col>

                </el-row>
            </el-card>


        </el-form>


                <span slot="footer" class="dialog-footer" >
                        <el-button type="primary" @click="add" >SUBMIT</el-button>
                </span>




    </div>
</template>

<script>
    var token =  localStorage.getItem('token')
    export default {
        name: "emAdd.vue",
        data(){
            return{
                isdowning:false,
                setitem:[],
                setForm:{},
                lable:[],
                role:"",
                fileList:[],
                myHeaders: {token: token},
                link:[],
                urFormVisible:false,
                rules:{

                },

            }

        },
        async created() {
            this.role=localStorage.getItem("role");
            this.setForm =  JSON.parse(localStorage.getItem('setform'));
            this.getInfo()
            document.title = "FIELD SETTING - Welcome to BTI Wireless’s RMA Process System";
        },
        methods:{
            async getInfo(){
                const result=await this.$http.get("sysset/info");
                if (result.data.error_code!==0){
                    this.getCol();
                }else {
                    console.log(result.data.data.faulty_category)
                    this.setitem=result.data.data.cols;
                    this.setForm=result.data.data.setform;
                    this.lable=result.data.data.lable;


                }
            },
            async getCol(){
                const result=await this.$http.get("sysset/getCol");
                if (result.data.error_code!==0){

                }else {
                    this.setitem=result.data.data.cols;
                    this.setForm=result.data.data.setform;
                }
            },
            async add() {
                this.$refs.setFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }

                    const result=await this.$http.post("sysset/add",this.setForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.$router.push('/rmaList');
                        const setformm=await this.$http.get("sysset/info");
                        localStorage.setItem("setform",JSON.stringify(setformm.data.data.setform));

                    }
                });
            },
            deleteItem(key,index){
                this.setForm[key].splice(index,1);
            },
            addinput(key){
                this.setForm[key].push("");
            }

        }
    }
</script>

<style lang="less" scoped>
    .el-table{

    }
    .el-breadcrumb{
        padding-top: 10px;
    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
    .el-select{
        width: 100%;
    }
    .el-image{
        width: 25%;
        margin: 5px;
        max-width: 150px;
    }
</style>
